import React from 'react';
export var ODVSpace = function (props) {
    var h = props.h, children = props.children;
    return React.createElement("div", { style: { height: h } }, children);
};
//# sourceMappingURL=ODVSpace.js.map